/* eslint-disable no-param-reassign */
import axios from 'axios';
import { appConfig } from './config';

// ----------------------------------------------------------------------
const cmsAxiosInstance = axios.create({
  baseURL: `${appConfig.cmsBaseUrl}/api`,
});

cmsAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || 'Something went wrong',
    ),
);

export default cmsAxiosInstance;
